import { Link } from 'react-router-dom'
import React, {useState} from "react";
import styled from "styled-components";
import { HamburgerMenu } from "../hamburgerMenu";


const NavbarContainer = styled.div`
  
  /* border-bottom: 1px solid #fff; */
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  height: 100px;
  align-items: center;
  padding: 0 1.5em;
  position: fixed;
  &.active{
    background-color: black;
    transition: all 0.3s ease-in-out;
  }
  transition: all 0.3s ease-in-out;
  
`;



export function Navbar() {


  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 80)
    setNavbar(true);
    else
    setNavbar(false);
  }

  window.addEventListener('scroll', changeBackground)

  return (
    <NavbarContainer className={navbar ? 'active' : ''}>
      <HamburgerMenu />
      <nav className="navbar">
        <img src="https://i.imgur.com/WEO9PhF.png" alt="repose" />
        <div className="links">
          <Link to="/"> Home</Link>
          <Link to="/meditate"> Meditate</Link>
          <Link to="/sleep"> Sleep Stories</Link>
          <Link to="/"> Music</Link>
          <Link to="/"> Body</Link>
          <Link to="/breathe"> Breathe</Link>
        </div>
      </nav>
    </NavbarContainer>
  );
}
